export const BUTTON_COLOR = '#026cff';
export const BUTTON_TEXT = 'Pay';
export const BUTTON_TEXT_FONT = 'Roboto';
export const BUTTON_TEXT_SIZE = 15;
export const BUTTON_TEXT_COLOR = '#ffffff';
export const BUTTON_HEIGHT = 30;
export const BUTTON_WIDTH = 40;
export const BUTTON_MARGIN_TOP = 50;
export const BUTTON_MARGIN_LEFT = 130;
export const BUTTON_BORDER_WIDTH = 0;
export const BUTTON_BORDER_RADIUS = 0;
export const BUTTON_BORDER_COLOR = '#000000';
